export function BellIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0Z"
        fill="#00C238"
      />
      <path
        d="M20.2498 17.14L11.4698 18.91C11.1598 18.97 10.8698 18.75 10.8498 18.44C10.7498 17.21 11.0998 16.02 11.7898 15.08L11.3098 12.72C10.9398 10.87 12.1298 9.06997 13.9798 8.69997C15.8298 8.32997 17.6298 9.51997 17.9998 11.37L18.4798 13.73C19.4798 14.34 20.2598 15.3 20.6498 16.47C20.7498 16.77 20.5598 17.08 20.2598 17.15L20.2498 17.14Z"
        fill="#FDFDFD"
      />
      <path
        d="M13.0498 19.7501L16.3598 19.0801C16.5398 19.9901 15.9498 20.8901 15.0398 21.0701C14.1298 21.2501 13.2298 20.6601 13.0498 19.7501Z"
        fill="#FDFDFD"
      />
    </svg>
  )
}
